import { emailSchema } from 'utils/schema';
import * as yup from 'yup';
import { TRequestResetPasswordFormValues } from './RequestResetPassword.types';

export const requestResetPasswordSchema = yup
  .object<TRequestResetPasswordFormValues>()
  .shape({
    email: emailSchema.required('Email is required'),
  });
